import { firstDayOfMonth, formatDate, lastDayOfMonth } from "./DateUtils";
import { getTenant } from "./TenantUtils";

// mes de 1 (janeiro) a 12; filtra pela vigência final (renovações) ou inicial
export const getLinkFichasDoMes = (mes: number, ano: number, seguradora?: { nome?: string }, corretor?: { nome?: string }, vigencia = 'Vigência Final') => {
    const firstDay = firstDayOfMonth(mes - 1, ano);
    const lastDay = lastDayOfMonth(mes - 1, ano);

    const filtroSeguradora = seguradora ? `;Seguradora_Contém=${seguradora?.nome}` : '';
    const filtroCorretor = corretor ? `;Corretor_Contém=${corretor?.nome}` : '';
    
    return `/${getTenant()}/seguros?filters==${vigencia}_Maior ou igual=${formatDate(firstDay)};${vigencia}_Menor ou igual=${formatDate(lastDay)}${filtroSeguradora}${filtroCorretor}`;
}